import styled from 'styled-components';

interface ItemProps {
  readonly width?: string;
}

export const CreateAcountWrapper = styled.div`
  width: 100%;
  display: flex;
  font-size: 16px;
  align-items: center;  
  flex-direction: column;
  box-sizing: border-box;
  @media(max-width: 426px) {
    padding: 0 15px;
  }
`;

export const LoginLogo = styled.div`
  display: flex;  
  align-content: center;
  flex-direction: column;
`;

export const LoginLogoSpan = styled.span`
  margin: 0 -3px;
  font-size: 18px;
  font-weight: 300;  
`;

export const ForgotForm = styled.form`
  width: 100%;
  margin-bottom: 20px;
`;

export const Title = styled.span`
  display: flex;
  font-size: 1.5em;
  font-weight: 600;
  color: #2B323B;
  line-height: 120%;
  font-style: normal;
  align-items: center;
  margin-bottom: 22px;
  letter-spacing: -0.02em;
  font-family: 'Proxima Nova';
`;

export const LoginForm = styled.form`
  width: 100%;  
  margin-top: 32px;
  padding-top: 101px;
  box-sizing: border-box;
  border-top: 1px solid #EBEDF2;
  @media (max-width: 426px) {
    padding-top: 5vh;
  }
`;

export const FormField = styled.div<ItemProps>`  
  position: relative;
  margin-bottom: 19px;  
  width: ${props => (props.width ? props.width : 'calc(50% - 12px)')};
  & > button {
    width: 100%;
  }
`;

export const LabelForm = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const RowContainer = styled.div`
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
`;

export const TermsWrapper = styled.div`
  display: flex;
  margin-top: 9px;
  align-items: center;
`;

export const Terms = styled.span`
  font-size: 16px;
  color: #38424D;
  font-weight: 400;
  line-height: 120%;
  font-style: normal;
  font-family: 'Proxima Nova';
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none;   /* Chrome/Safari/Opera */
  -khtml-user-select: none;    /* Konqueror */
  -moz-user-select: none;      /* Firefox */
  -ms-user-select: none;       /* Internet Explorer/Edge */
  user-select: none;           /* Non-prefixed version, currently supported by any browser but < IE9 */
`;

export const Link = styled.a`
  color: #017CFF;
  text-decoration: underline;
  &:hover {
    cursor: pointer;
  }
`;

